import { Client } from '@/type';

// eslint-disable-next-line import/prefer-default-export
export function name(client: { firstName: string, lastName: string }): string {
  return `${client.lastName}, ${client.firstName}`;
}
